import React, { useEffect, useState } from 'react';
import { CustomerReview, ServiceAccordion, GalleryCarousel } from './C_Mobile.jsx';
import { Footer2, Navbar2, GoogleTranslateWidget } from './C_Mobile.jsx';
import { Button, styled, Typography } from '@mui/material';
import './Page.css';
import HeroSection from './new_hero.jsx';

const ForUseOFStuff = styled('div')({});

const GridBox = styled('div')({
  display: 'grid',
  alignItems: 'center',
});

const StyledH2 = styled('h2')(({ theme }) => ({
  marginBottom: '24px',
  textAlign: 'center',
  fontSize: '3rem',
  fontWeight: 300,
  letterSpacing: '0.2em',
  textTransform: 'uppercase',
  position: 'relative',
  '&::after': {
    content: '""',
    display: 'block',
    width: '80px',
    height: '2px',
    backgroundColor: 'rgba(255,255,255,0.5)',
    margin: '16px auto 0',
    transition: 'all 0.4s ease',
  },
  ':hover': {
    cursor: 'pointer',
  // letterSpacing: '0.1em',

    '&::after': {
      width: '120px',
      backgroundColor: 'white',
    }
  }
}));

const App = () => {
  const [data, setData] = useState(null);
  
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`/data.json`);
      const result = await response.json();
      setData(result);
    };

    fetchData();
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  const haircuts = data.services.find(s => s.id === 'haircuts');
  const hairBeard = data.services.find(s => s.id === 'hair-beard');
  const beard = data.services.find(s => s.id === 'beard');
  const addOns = data.services.find(s => s.id === 'add-ons');


  return (
    // overflowY: 'scroll',
    <div className="background-container tint fixed-top" style={{ maxHeight: '100vh', color: 'white' }}>

      <HeroSection />

      <section id="AboutUs2" style={{ backgroundColor: "black" }}>
        <ForUseOFStuff sx={{ py: { xs: 8, md: 12, lg: 15 } }}>
          <div style={{ marginLeft: '10%', marginRight: '10%' }}>
            <div className="" style={{ zIndex: 1 }}>
              <StyledH2 data-aos='fade-down'>About Us</StyledH2>
              <GridBox sx={{ gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: { xs: 4, md: 8 } }}>
                <div style={{ position: "relative", borderRadius: "4px", overflow: "hidden", boxShadow: "0 20px 40px rgba(0,0,0,0.3)" }} data-aos='fade-right'>
                  <div style={{ width: '100%', paddingBottom: '66.67%' }}>
                    <img src="./images/about-us.png"
                      style={{
                        position: 'absolute', top: 0, left: 0, width: '100%', height: '110%', objectFit: 'cover',
                        borderRadius: '2%'
                      }}
                      alt="" />
                  </div>
                  <div style={{ position: "absolute", bottom: "16px", left: "16px", zIndex: 0, fontSize: "0.7rem", letterSpacing: "0.1em", opacity: 0.8 }}>
                    THE LOBBY BARBERSHOP EST. 2025
                  </div>
                </div>
                <div style={{ marginBottom: "24px", fontSize: "1.1rem", lineHeight: 1.8, letterSpacing: "0.05em" }} data-aos='fade-left'>
                  <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.8, letterSpacing: '0.05em', mb: 3 }}>
                    <span style={{ fontSize: '2.2em', float: 'left', lineHeight: '0.8', marginRight: '8px' }}
                    >{`T`}</span>he Lobby Barbershop is more than just a place to get a haircut - it’s an experience crafted for those who appreciate tradition with a contemporary edge.
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.8, letterSpacing: '0.05em' }}>
                    Founded in 2025, The Lobby was built on a simple mission: to elevate the grooming experience.
                    We offer premium barbering and salon services in a refined space that balances luxury with comfort.
                    Our master barbers and stylists blend classic techniques with contemporary trends to deliver precise, personalized results—helping you look sharp, feel confident, and leave with a style that’s unmistakably yours.
                  </Typography>
                </div>
              </GridBox>
            </div>
          </div>
        </ForUseOFStuff>
      </section>

      <section id="Gallery" className="py-5" style={{ background: 'linear-gradient(180deg, #000 0%, #191919 100%)' }}>
        <div className="container">
          <StyledH2 data-aos='fade-down'>Gallery</StyledH2>
          <div data-aos='fade-down'>
            <GalleryCarousel images={data.Images} />
          </div>
        </div>
      </section>

      <section id="Services2" className="py-5" style={{ background: 'linear-gradient(180deg, rgba(25,25,25,1) 0%, rgba(25,25,25,1) 60%, rgba(0,0,0,1) 100%)' }}>
        <div className="container">
          <StyledH2 data-aos='fade-down'>Our Services</StyledH2>
          {/* <div className="row" style={{ margin: '1%' }}>
            <div className="col-md-6 mb-30" data-aos='fade-right'><ServiceAccordion title="Haircut Services" services={data.Services1} /></div>
            <div className="col-md-6 mb-30" data-aos='fade-left'><ServiceAccordion title="Beard Services" services={data.Services2} /></div>
          </div> */}

          <div className="row" style={{ margin: '1%' }}>

            <div className="col-md-6">

              <br />

              <div className="mb-30" data-aos='fade-right'>
                <h3 style={{ color: 'white' }}>{haircuts.title}</h3>
                <ServiceAccordion services={haircuts.services} />
              </div>

              <br />
              <div className="mb-30" data-aos='fade-left'>
                <h3 style={{ color: 'white' }}>{hairBeard.title}</h3>
                <ServiceAccordion services={hairBeard.services} />
              </div>

            </div>

            <div className="col-md-6">
              <br />

              <div className="mb-30" data-aos='fade-left'>
                <h3 style={{ color: 'white' }}>{addOns.title}</h3>
                <ServiceAccordion services={addOns.services} />
              </div>

              <br />

              <div className="mb-30" data-aos='fade-right'>
                <h3 style={{ color: 'white' }}>{beard.title}</h3>
                <ServiceAccordion services={beard.services} />
              </div>
            </div>
          </div>
          <center>
            <Button component="a" data-aos='fade-down' href="https://web.getsquire.com/brands/the-lobby" variant="contained" size="large"
              whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}
              sx={{ px: 6, py: 1.5, mt: 3, fontSize: "1rem", backgroundColor: "white", color: "black", textDecoration: "none", border: "1px solid", }}
            >
              Book Your Appointment
            </Button>
          </center>
        </div>
      </section>

      <section id="reviews" className="py-5" style={{ background: 'linear-gradient(180deg, #000 0%, #191919 100%)' }}>
        <div className="container">
          <StyledH2 data-aos='fade-down'>Reviews</StyledH2>
          <div className="row">
            <div className="col-md-4 my-1" data-aos='fade-up'><CustomerReview name={data.Reviews[0].name} date={data.Reviews[0].date} description={data.Reviews[0].desc} /></div>
            <div className="col-md-4 my-1" data-aos='fade-up'><CustomerReview name={data.Reviews[1].name} date={data.Reviews[1].date} description={data.Reviews[1].desc} /></div>
            <div className="col-md-4 my-1" data-aos='fade-up'><CustomerReview name={data.Reviews[2].name} date={data.Reviews[2].date} description={data.Reviews[2].desc} /></div>
          </div>
        </div>
      </section>

      <div style={{ backgroundColor: '#131212' }}><Footer2 /></div>
    </div>
  );
};

export default App;
